function _typeof(obj) { if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") { _typeof = function _typeof(obj) { return typeof obj; }; } else { _typeof = function _typeof(obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }; } return _typeof(obj); }

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } }

function _createClass(Constructor, protoProps, staticProps) { if (protoProps) _defineProperties(Constructor.prototype, protoProps); if (staticProps) _defineProperties(Constructor, staticProps); return Constructor; }

function _possibleConstructorReturn(self, call) { if (call && (_typeof(call) === "object" || typeof call === "function")) { return call; } return _assertThisInitialized(self); }

function _assertThisInitialized(self) { if (self === void 0) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return self; }

function _getPrototypeOf(o) { _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf : function _getPrototypeOf(o) { return o.__proto__ || Object.getPrototypeOf(o); }; return _getPrototypeOf(o); }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function"); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, writable: true, configurable: true } }); if (superClass) _setPrototypeOf(subClass, superClass); }

function _setPrototypeOf(o, p) { _setPrototypeOf = Object.setPrototypeOf || function _setPrototypeOf(o, p) { o.__proto__ = p; return o; }; return _setPrototypeOf(o, p); }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

import React, { PureComponent } from 'react';
import PropTypes from 'prop-types';
import classNames from 'classnames';
import EBPropTypes from 'js-utils/prop-types';
import Icon from '../icon/Icon';
import { ICON_TYPE_PROP_TYPE } from '../icon/constants';
import Button from '../button/Button';
import { STYLE_NONE } from '../button/constants';
import { ACTIVE_TEXT_BUTTON_COLOR, DISABLED_CLOSE_BUTTON_COLOR, ENABLED_CLOSE_BUTTON_COLOR, STYLES, STYLE_DEFAULT, STYLE_OUTLINED } from './constants';
import CrossChunkySvg from '../iconography/icons/CrossChunky';

var AsideElement = function AsideElement(_ref) {
  var image = _ref.image,
      label = _ref.label,
      iconType = _ref.iconType,
      iconColor = _ref.iconColor;
  var component = null;

  if (iconType) {
    component = React.createElement("div", {
      className: "eds-tag__icon eds-tag__item",
      "data-spec": "tag-icon"
    }, React.createElement(Icon, {
      type: iconType,
      size: "small",
      color: iconColor
    }));
  }

  if (image) {
    component = React.createElement("div", {
      className: "eds-tag__image eds-tag__item",
      "data-spec": "tag-image"
    }, React.createElement("img", {
      className: "eds-tag__image--img",
      src: image,
      alt: label
    }));
  }

  return component;
};

var CloseButton = function CloseButton(_ref2) {
  var shouldShow = _ref2.shouldShow,
      onClick = _ref2.onClick,
      isDisabled = _ref2.isDisabled,
      backgroundColor = _ref2.backgroundColor;
  var component = null;

  if (shouldShow) {
    var buttonColor;

    if (isDisabled) {
      buttonColor = DISABLED_CLOSE_BUTTON_COLOR;
    } else if (backgroundColor) {
      buttonColor = ACTIVE_TEXT_BUTTON_COLOR;
    } else {
      buttonColor = ENABLED_CLOSE_BUTTON_COLOR;
    }

    component = React.createElement("div", {
      className: "eds-tag__close-button eds-tag__item"
    }, React.createElement(Button, {
      onClick: onClick,
      style: STYLE_NONE,
      disabled: isDisabled
    }, React.createElement(Icon, {
      type: React.createElement(CrossChunkySvg, null),
      size: "small",
      color: buttonColor
    })));
  }

  return component;
};

var Tag =
/*#__PURE__*/
function (_PureComponent) {
  _inherits(Tag, _PureComponent);

  function Tag(props) {
    var _this;

    _classCallCheck(this, Tag);

    _this = _possibleConstructorReturn(this, _getPrototypeOf(Tag).call(this, props));
    _this.state = {
      isActive: props.initialIsActive
    };
    return _this;
  }

  _createClass(Tag, [{
    key: "componentWillReceiveProps",
    value: function componentWillReceiveProps(newProps) {
      if (newProps.initialIsActive !== undefined) {
        this.setState({
          isActive: newProps.initialIsActive
        });
      }
    }
  }, {
    key: "_toggleActive",
    value: function _toggleActive() {
      var onActiveToggle = this.props.onActiveToggle;

      if (this._isInteractive()) {
        this.setState(function (_ref3) {
          var isActive = _ref3.isActive;
          return {
            isActive: !isActive
          };
        });
        var isActive = this.state.isActive;

        if (onActiveToggle) {
          onActiveToggle(!isActive);
        }
      }
    }
  }, {
    key: "_handleClose",
    value: function _handleClose() {
      var _this$props = this.props,
          onClose = _this$props.onClose,
          isDisabled = _this$props.isDisabled;

      if (!isDisabled && onClose) {
        onClose();
      }
    }
  }, {
    key: "_handleKeyDown",
    value: function _handleKeyDown(e) {
      if (e.key === 'Enter') {
        this._toggleActive();
      }
    }
  }, {
    key: "_isInteractive",
    value: function _isInteractive() {
      var _this$props2 = this.props,
          isDisabled = _this$props2.isDisabled,
          isStatic = _this$props2.isStatic;
      return !isDisabled && !isStatic;
    }
  }, {
    key: "_getTagClasses",
    value: function _getTagClasses(_ref4) {
      var _classNames;

      var style = _ref4.style,
          isActive = _ref4.isActive,
          isDisabled = _ref4.isDisabled,
          isClosable = _ref4.isClosable,
          isInteractive = _ref4.isInteractive,
          image = _ref4.image,
          iconType = _ref4.iconType,
          backgroundColor = _ref4.backgroundColor,
          showOverflow = _ref4.showOverflow;
      var tagClasses = classNames('eds-tag', (_classNames = {}, _defineProperty(_classNames, "eds-tag--".concat(style), style), _defineProperty(_classNames, "eds-tag--active eds-tag--active--".concat(style), isActive), _defineProperty(_classNames, "eds-tag--disabled eds-tag--disabled--".concat(style), isDisabled), _defineProperty(_classNames, "eds-tag--closeable eds-tag--closeable--".concat(style), isClosable), _defineProperty(_classNames, "eds-tag--interactive eds-tag--interactive--".concat(style), isInteractive), _defineProperty(_classNames, 'eds-tag--with-image', image), _defineProperty(_classNames, 'eds-tag--with-icon', iconType && !image), _defineProperty(_classNames, "".concat(backgroundColor, " eds-tag__background--").concat(style), backgroundColor && !isDisabled), _defineProperty(_classNames, 'eds-tag--show-overflow', showOverflow), _classNames));
      return tagClasses;
    }
  }, {
    key: "_getTextClasses",
    value: function _getTextClasses(_ref5) {
      var isDefault = _ref5.isDefault,
          isOutlined = _ref5.isOutlined,
          isActive = _ref5.isActive,
          shouldShowClose = _ref5.shouldShowClose,
          backgroundColor = _ref5.backgroundColor,
          isDisabled = _ref5.isDisabled;
      var textClasses = classNames('eds-tag__text', 'eds-tag__item', {
        'eds-text-bs eds-text-weight--heavy': isDefault,
        'eds-text-bm': isOutlined,
        'eds-text-color--grey-800': isOutlined && !isActive,
        'eds-tag__text--active--outlined': isOutlined && isActive,
        'eds-tag__text--small-padding': shouldShowClose,
        'eds-tag__text--orange-shadow': isDefault && backgroundColor && !isDisabled,
        'eds-tag__text--background eds-text-color--white': backgroundColor
      });
      return textClasses;
    }
  }, {
    key: "render",
    value: function render() {
      var _this$props3 = this.props,
          image = _this$props3.image,
          children = _this$props3.children,
          isClosable = _this$props3.isClosable,
          isDisabled = _this$props3.isDisabled,
          isCloseButtonRemovable = _this$props3.isCloseButtonRemovable,
          label = _this$props3.label,
          iconType = _this$props3.iconType,
          backgroundColor = _this$props3.backgroundColor,
          showOverflow = _this$props3.showOverflow,
          style = _this$props3.style;
      var isActive = this.state.isActive;

      var isInteractive = this._isInteractive();

      var shouldShowClose = isClosable && !isCloseButtonRemovable || isClosable && isActive && isCloseButtonRemovable;
      var isDefault = style === STYLE_DEFAULT;
      var isOutlined = style === STYLE_OUTLINED;

      var tagClasses = this._getTagClasses({
        style: style,
        isActive: isActive,
        isDisabled: isDisabled,
        isClosable: isClosable,
        isInteractive: isInteractive,
        image: image,
        iconType: iconType,
        backgroundColor: backgroundColor,
        showOverflow: showOverflow
      });

      var textClasses = this._getTextClasses({
        isDefault: isDefault,
        isOutlined: isOutlined,
        isActive: isActive,
        shouldShowClose: shouldShowClose,
        backgroundColor: backgroundColor,
        isDisabled: isDisabled
      });

      var iconColor;
      var backgroundMask;
      var backgroundClasses;

      if (backgroundColor) {
        backgroundClasses = classNames({
          'eds-tag__background-mask': isDefault
        });
        iconColor = ACTIVE_TEXT_BUTTON_COLOR;
        backgroundMask = React.createElement("div", {
          className: backgroundClasses
        });
      }

      var interactiveProperties = {};

      if (isInteractive) {
        interactiveProperties = {
          tabIndex: 0,
          role: 'button',
          onClick: this._toggleActive.bind(this),
          onKeyDown: this._handleKeyDown.bind(this)
        };
      }

      return React.createElement("div", _extends({}, interactiveProperties, {
        className: tagClasses,
        key: children
      }), backgroundMask, React.createElement(AsideElement, {
        image: image,
        label: label,
        iconType: iconType,
        iconColor: iconColor
      }), React.createElement("span", {
        className: textClasses
      }, children), React.createElement(CloseButton, {
        shouldShow: shouldShowClose,
        onClick: this._handleClose.bind(this),
        isDisabled: isDisabled,
        isActive: isActive,
        backgroundColor: backgroundColor
      }));
    }
  }]);

  return Tag;
}(PureComponent);

_defineProperty(Tag, "propTypes", {
  /**
  * The main content that the tag should be displaying
  **/
  children: PropTypes.node.isRequired,

  /**
  * Optional image URL that should be displayed by the tag
  **/
  image: PropTypes.string,

  /**
  * Label to be associated with the image if passed through
  **/
  label: EBPropTypes.translation,

  /**
  * Optional icon that should be displayed by the tag
  **/
  iconType: ICON_TYPE_PROP_TYPE,
  //may not need, check with design

  /**
  * Prop dictating whether the tag should appear in an active state, or not.
  * Interaction still design still in progress so focus more on styling for now.
  **/
  initialIsActive: PropTypes.bool,
  // TODO: This should be updated to take an enum of colors so we can validate

  /**
  * Changes the color of the background color of the tag.
  **/
  backgroundColor: PropTypes.string,

  /**
  * Whether or not the tag should be set to a disabled state
  **/
  isDisabled: PropTypes.bool,

  /**
  * Whether or not the tag should include a close button
  * to dismiss it.
  **/
  isClosable: PropTypes.bool,

  /**
  * Whether or not the tag should change after being clicked and be reachable by keyboard.
  **/
  isStatic: PropTypes.bool,

  /**
  * Whether or not the tag close button should hide when the tag is not active.
  **/
  isCloseButtonRemovable: PropTypes.bool,

  /**
  * Callback function to be called when the tag is 'dismissed'
  **/
  onClose: PropTypes.func,

  /**
  * Callback function called when the specific tag is clicked as 'active'
  **/
  onActiveToggle: PropTypes.func,

  /**
   * Whether or not to allow overflow of children to be visible
   */
  showOverflow: PropTypes.bool,

  /**
   * Changes the style of the tag
   * Available styles: default and outlined
   */
  style: PropTypes.oneOf(STYLES)
});

_defineProperty(Tag, "defaultProps", {
  isClosable: false,
  isCloseButtonRemovable: false,
  isDisabled: false,
  isStatic: false,
  showOverflow: false,
  style: STYLE_DEFAULT
});

export { Tag as default };